import { showToastMessage } from 'enable-ui';

import { includes } from 'lodash';

import { ERROR_MESSAGE } from 'constants/message';

export const httpRequestErrors = (errors: any) => {
  if (Array.isArray(errors.errors)) {
    errors.errors.forEach((error: any) => {
      showToastMessage('error', error);
    });

    return;
  }

  if (Array.isArray(errors.message)) {
    errors.message.forEach((message: any) => {
      switch (true) {
        case includes(message, 'stationId'):
          showToastMessage('error', message.replace('stationId', 'Station ID'));

          break;

        case includes(message, 'trainerIds must contain no more than 4 elements'):
          showToastMessage('error', 'Please select a maximum of 4 trainers!');
          break;

        default:
          showToastMessage('error', message);

          break;
      }
    });

    return;
  }

  if (typeof errors.message === 'string') {
    showToastMessage('error', errors.message);

    return;
  }

  if (typeof errors.errors === 'string') {
    showToastMessage('error', errors.errors);

    return;
  }

  showToastMessage('error', ERROR_MESSAGE.UNKNOWN);
};
